import {apiFetch} from "../../api";
import {BASE_URL as u} from "../../../commonUrls";

const BASE_URL = `${u}/category`;
//const USER_ID = "u-c136202b-94f4-4e51-aa0b-72db0503c362";

export async function getAllCategories(){
  const res = await apiFetch(`${BASE_URL}/user`);
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}

export async function createCategory(categoryType, categoryName){
  const payload = { userId: 0, categoryType: categoryType,  categoryName: categoryName };
  const res = await apiFetch(BASE_URL,{
    method:"POST",
    headers:{ "Content-Type":"application/json"},
    body: JSON.stringify(payload)
  });
  return res.json();
}

export async function deleteCategory(id, userId){
  await apiFetch(`${BASE_URL}/${id}`,{ method:"DELETE"});
}

export async function updateCategory(id,categoryType, categoryName){
  const payload = { userId: 0, 
    categoryType: categoryType, 
    categoryName: categoryName,
    isActive: true
  };
  const res = await apiFetch(`${BASE_URL}/${id}`,{
    method:"PUT",
    headers:{ "Content-Type":"application/json"},
    body: JSON.stringify(payload)
  });
  return res.json();
}
